<template>
  <div
    class="voice-selector old-globals"
    :class="{ 'voice-selector-row': displayRow }"
  >
    <label for="voice" class="voice-label">Voice</label>
    <md-field>
      <md-select
        id="voice"
        :value="voiceKey"
        :disabled="readonly"
        name="voice"
        class="voice-select"
        @input="selectVoice"
        @md-opened="selectOpen"
        @md-closed="selectClosed"
      >
        <md-optgroup
          v-for="[aAvatarKey, avatarVoices] in Object.entries(voicesByAvatar)"
          :key="aAvatarKey"
          :label="aAvatarKey"
        >
          <md-option
            v-for="voice in avatarVoices"
            :key="voice.id"
            class="voice-option"
            :disabled="disabledVoices.includes(voice.id)"
            :value="voice.id"
          >
            {{ voice.name.en }}
            <span v-if="isOpen" class="description">{{ voice.description.en }}</span>
          </md-option>
        </md-optgroup>
      </md-select>
      <md-button
        class="md-icon-button md-dense play-button"
        :disabled="loadingAudio"
        @click="playSample"
      >
        <md-icon>
          {{ loadingAudio ? 'hourglass_top' : 'volume_up' }}
        </md-icon>
      </md-button>
    </md-field>
  </div>
</template>

<script>
import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import servicesClient from '../../providers/servicesClient';

export default {
  name: 'voice-selector',
  props: {
    avatarKey: {
      type: String,
      default: null,
    },
    voiceKey: {
      type: String,
      default: null,
    },
    voices: {
      type: Array,
      default: () => [],
    },
    disabledVoices: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    displayRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      loadingAudio: false,
    }
  },
  computed: {
    voicesByAvatar() {
      return groupBy(this.sortedVoices, 'avatarKey');
    },
    sortedVoices() {
      return sortBy(this.voices, [
        (v) => {
          return v.avatarKey !== this.avatarKey; // avatar's voices go first
        }
      ]);
    }
  },
  methods: {
    selectVoice(value) {
      this.$emit('update', value);
    },
    selectOpen() {
      this.isOpen = true;
    },
    selectClosed() {
      this.isOpen = false;
    },
    async playSample() {
      this.loadingAudio = true;
      servicesClient.post('generate-audio', {
        text: 'I\'m not feeling well',
        voiceId: this.voiceKey,
      }).then(response => {
        const audio = new Audio(response.data.s3Location);
        audio.play();
        this.loadingAudio = false;
      });
    }
  }
}
</script>

<style scoped>
.voice-selector {
  display: flex;
  flex-direction: column;
}

.voice-selector-row {
  flex-direction: row;
  align-items: center;
}

.voice-label {
  margin-right: 10px;
}

.voice-select {
  position: relative;
}

.md-optgroup >>> .md-subheader {
  font-size: 16px;
  font-weight: 400;
  padding-left: 24px;
}

.voice-option >>> .md-list-item-text {
  display: flex;
  flex-direction: row;
  position: relative;
  width: 440px;
}

.description {
  position: absolute;
  font-style: italic;
  left: 100px;
  top: 0px;
}

.icon-column {
  position: absolute;
  left: 210px;
  top: 0px;
}

.play-button {
  position: absolute;
  right: 30px;
  top: 0;
}

</style>
